<template functional>
  <span class="icon">
    <i
      class="mdi"
      :class="[props.size, props.icon]"
      :style="{color: props.color}"
      aria-hidden="true"
    ></i>
  </span>
</template>

<script>
export default {
  name: "MatIcon",
  props: {
    icon: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "mdi-24px"
    },
    color: {
      type: String,
      default: ""
    }
  }
};
</script>
